import { render, staticRenderFns } from "./FeeRateForm.vue?vue&type=template&id=a3064ddc"
import script from "./FeeRateForm.vue?vue&type=script&lang=js"
export * from "./FeeRateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports